import store from "../config/store";

const authorizedFetch = (url, options = {}) => {
  const { token } = store.getState().user.payload;

  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: token,
      "Content-Type": "application/json"
    }
  });
};

export default authorizedFetch;



// WEBPACK FOOTER //
// ./src/utilities/authorizedFetch.js